import { Line } from '../../models/Line'
import { invoiceCategoryOptions } from '../settings/Options'
import { RemovableItemContainer } from './RemovableItemContainer'
import { SelectedItem } from './SelectedItem'

export const ExpenseLine = ({
    line,
    onUpdate,
    onRemove,
    onEdit,
}: {
    line: Line
    onUpdate: (line: Line) => void
    onRemove: () => void
    onEdit: () => void
}) => {
    const amount = line.total !== undefined ? (isNaN(line.total) ? 0 : line.total) : 0

    const handleCategoryChange = (option: { id: string; title: string }) => {
        onUpdate(
            line.clone({
                category: option.id === 'none' ? undefined : option.id,
                memo: option.id === 'none' ? 'Expense' : `${option.title} expense`,
            })
        )
    }

    return (
        <RemovableItemContainer onRemove={onRemove}>
            <SelectedItem
                primaryDropdownOptions={categoryDropdownOptions}
                selectedPrimaryDropdownOptionID={line.category ?? 'none'}
                onSelectPrimaryDropdownOption={handleCategoryChange}
                primaryDropdownClassName="min-w-[210px]"
                amount={amount}
                onAmountChange={(newTotal) => onUpdate(line.clone({ total: newTotal }))}
                primaryButtonTitle="Edit"
                onClickPrimaryButton={onEdit}
            />
        </RemovableItemContainer>
    )
}

const categoryDropdownOptions = [
    { id: 'none', title: 'None' },
    ...invoiceCategoryOptions.map((option) => ({
        id: option.value,
        title: option.label,
    })),
]
